import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { HiOutlineDocumentReport as HiOutlineDocumentReportIcon } from 'react-icons/hi';
import CollapsiblePanel from '../shared/CollapsiblePanel';

const ManagementSidebar: React.FC = () => {
  const { t } = useTranslation();
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isReportsActive = location.pathname.startsWith('/management/reports');

  return (
    <div className={`dashboard-sidebar management-sidebar-fullheight${collapsed ? ' collapsed' : ''}`}>
      <CollapsiblePanel
        title={t('management.managementPanel')}
        collapsed={collapsed}
        onToggleCollapse={() => setCollapsed(!collapsed)}
      >
        <ul className="sidebar-list">
          <li
            className={`sidebar-menu-item${isReportsActive ? ' active' : ''}`}
            onClick={() => navigate('/management/reports')}
            style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', padding: '10px 0', fontSize: '1.08rem', color: '#222', borderRadius: 6 }}
          >
            {HiOutlineDocumentReportIcon({ className: 'sidebar-icon' })}
            <span>{t('management.reports')}</span>
          </li>
        </ul>
      </CollapsiblePanel>
    </div>
  );
};

export default ManagementSidebar; 